/** Keeps `<meta name="theme-color">` in sync with `--app-theme-color` (toolbar tint). */
export function syncThemeColor(): void {
  const color = getComputedStyle(document.body)
    .getPropertyValue('--app-theme-color')
    .trim();
  if (!color) return;

  document.querySelectorAll('meta[name="theme-color"]').forEach((node) => node.remove());

  const meta = document.createElement('meta');
  meta.name = 'theme-color';
  meta.content = color;
  document.head.appendChild(meta);
}

export function watchThemeColor(): void {
  syncThemeColor();
  window
    .matchMedia('(prefers-color-scheme: dark)')
    .addEventListener('change', syncThemeColor);
}
